import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12( $firmSubCode: String!, $rTypeCode: String!, $firmMainCode: String!) {
    tbl_htl_room_type(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        r_type_code: { _eq: $rTypeCode }
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      bed_type
      bed
      min_pax
      max_pax
      min_adl
      max_adl
      min_chl
      max_chl
      total_room
      baby_start
      baby_end
      chl_start
      chl_end
      int_ID
    }
  }
`;

const GET_RCLASS = gql`
  query MyQuery($drctype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drctype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const GET_RTTYPE = gql`
  query MyQuery($drttype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drttype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const UPDATE_RTYPE = gql`
mutation UpdateRoomType(
  $firmSubCode: String!
  $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!
    $rBed: Int!
    $minPax: Int!
    $maxPax: Int!
    $minAdl: Int!
    $maxAdl: Int!
    $minChl: Int!
    $maxChl: Int!
    $totalRoom:Int!
    $babyStart: float8!
    $babyEnd: float8!
    $chlStart: float8!
    $chlEnd: float8!
) {
  update_tbl_htl_room_type_coop(
    where: {
      firm_sub_code_n: { _eq: $firmSubCode },
      r_type_code_n: { _eq: $rTypeCode }
    },
    _set: {
      r_type_name_n: $rTypeName,
      r_type_code_n: $rTypeCode,
      r_class_code_n: $rClassCode,
      bed_type_n: $rBedType,
      bed_n: $rBed,
      min_pax_n: $minPax,
      max_pax_n: $maxPax,
      min_adl: $minAdl,
      max_adl: $maxAdl,
      min_chl_n: $minChl,
      max_chl_n: $maxChl,
      total_room_n: $totalRoom,
      baby_start_n: $babyStart,
      baby_end_n: $babyEnd,
      chl_start_n: $chlStart,
      chl_end_n: $chlEnd
    }
  ) {
    affected_rows
  }
}
`;

const INSERT_RTYPE = gql`
  mutation InsertRoomType(
    $firmMainCode: String!
    $firmSubCode: String!
    $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!
    $rBed: Int!
    $minPax: Int!
    $maxPax: Int!
    $minAdl: Int!
    $maxAdl: Int!
    $minChl: Int!
    $maxChl: Int!
    $totalRoom: Int!
    $babyStart: float8!
    $babyEnd: float8!
    $chlStart: float8!
    $chlEnd: float8!
  ) {
    insert_tbl_htl_room_type(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        r_class_code: $rClassCode,
        r_type_code: $rTypeCode,
        r_type_name: $rTypeName,
        bed_type: $rBedType,
        bed: $rBed,
        min_pax: $minPax,
        max_pax: $maxPax,
        min_adl: $minAdl,
        max_adl: $maxAdl,
        min_chl: $minChl,
        max_chl: $maxChl,
        total_room: $totalRoom,
        baby_start: $babyStart,
        baby_end: $babyEnd,
        chl_start: $chlStart,
        chl_end: $chlEnd
      }
    ) {
      affected_rows
    }
  }
`;









const HotelRoomTypeCoop = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, rTypeCode: varCode },
  });
  const [UpdateRoomType] = useMutation(UPDATE_RTYPE);
  const [InsertRoomType] = useMutation(INSERT_RTYPE);

  const firmData = data && data.tbl_htl_room_type ? data.tbl_htl_room_type[0] : null;

 

  
  const [rClassName, setRClassName] = useState(firmData ? firmData.r_class_name : "");
  const [rClassCode, setRClassCode] = useState(firmData ? firmData.r_class_name : "");
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.r_type_code : "");
  const [rTypeName, setRTypeName] = useState(firmData ? firmData.r_type_name : "");
  const [rBedType, setRBedType] = useState(firmData ? firmData.bed_type : "");
  const [rBed, setBed] = useState(firmData ? firmData.bed : "");
  const [minPax, setMinPax] = useState(firmData ? firmData.min_pax : "");
  const [maxPax, setMaxPax] = useState(firmData ? firmData.max_pax: "");
  const [minAdl, setMinAdl] = useState(firmData ? firmData.min_adl : "");
  const [maxAdl, setMaxAdl] = useState(firmData ? firmData.max_adl: "");
  const [minChl, setMinChl] = useState(firmData ? firmData.min_chl : "");
  const [maxChl, setMaxChl] = useState(firmData ? firmData.max_chl : "");
  const [totalRoom, setTotalRoom] = useState(firmData ? firmData.total_room : "");
  const [babyStart, setBabyStart] = useState(firmData ? firmData.baby_start : "");
  const [babyEnd, setBabyEnd] = useState(firmData ? firmData.baby_end : "");
  const [chlStart, setChlStart] = useState(firmData ? firmData.chl_start : "");
  const [chlEnd, setChlEnd] = useState(firmData ? firmData.chl_end : "");
  const [rIntId, setRIntId] = useState(firmData ? firmData.int_ID : "");


  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const typerec = messages[currentLocale].typerec;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const select_a_room_class = messages[currentLocale].select_a_room_class;
  const select_a_room_type = messages[currentLocale].select_a_room_type;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const create_room_typerec = messages[currentLocale].create_room_typerec;
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_hotel = messages[currentLocale].managing_hotel;
  const firm_detail = messages[currentLocale].firm_detail;
  const agency_detail = messages[currentLocale].agency_detail;
  const sub_agency_detail = messages[currentLocale].sub_agency_detail;
  const sub_hotel_detail = messages[currentLocale].sub_hotel_detail;
  const main_department_tab = messages[currentLocale].main_department_tab;
  const sub_department_tab = messages[currentLocale].sub_department_tab;
  const rulesrec = messages[currentLocale].rulesrec;
  const account_cart_tab = messages[currentLocale].account_cart_tab;
  const bank_accounts_tab = messages[currentLocale].bank_accounts_tab;
  const room_class_tab = messages[currentLocale].room_class_tab;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_class_code = messages[currentLocale].room_class_code;
  const room_class_name = messages[currentLocale].room_class_name;
  const room_type_code = messages[currentLocale].room_type_code;
  const room_type_name = messages[currentLocale].room_type_name;
  const room_bed_title = messages[currentLocale].room_bed_title;
  const room_bed_type_title = messages[currentLocale].room_bed_type_title;
  const room_total_title = messages[currentLocale].room_total_title;
  const room_max_pax_title = messages[currentLocale].room_max_pax_title;
  const room_min_pax_title = messages[currentLocale].room_min_pax_title;
  const room_chl_max_title = messages[currentLocale].room_chl_max_title;
  const room_chl_min_title = messages[currentLocale].room_chl_min_title;
  const room_baby_start_title = messages[currentLocale].room_baby_start_title;
  const room_baby_end_title = messages[currentLocale].room_baby_end_title;
  const room_chl_start_title = messages[currentLocale].room_chl_start_title;
  const room_chl_end_title = messages[currentLocale].room_chl_end_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_name = messages[currentLocale].sub_department_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const dpr_update_successfully = messages[currentLocale].dpr_update_successfully;

  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;


  
  const { loading: drtLoading, error: drtError, data: drtData } = useQuery(GET_RTTYPE, {
    variables: { drttype: 'RTYP', lang: currentLocale },
  });

  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: { drctype: "RCLS", lang: currentLocale },
  });

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "BTYP", lang: currentLocale },
  });

  const roomClassSelectItemsC = drcData && drcData.tbl_gnl_def
  ? drcData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const roomClassSelectItems = drtData && drtData.tbl_gnl_def
  ? drtData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];
  

  

  
  

  
  
  
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");  
  
  console.log("Firm Data:", firmData);

  
  

  useEffect(() => {
    if (drtData && drtData.tbl_gnl_def) {
      const selectedRoomClass = drtData.tbl_gnl_def.find(item => item.code === rTypeCode);
      if (selectedRoomClass) {
        setRTypeName(selectedRoomClass.name);
      }
    }
  }, [rTypeCode, drtData]);

  useEffect(() => {
    if (firmData) {
      setRClassName(firmData.r_class_name);
      setRClassCode(firmData.r_class_code);
      setRTypeCode(firmData.r_type_code);
      setRTypeName(firmData.r_type_name);
      setRBedType(firmData.bed_type);
      setBed(firmData.bed);
      setMinPax(firmData.min_pax);
      setMaxPax(firmData.max_pax);
      setMinAdl(firmData.min_adl);
      setMaxAdl(firmData.max_adl);
      setMinChl(firmData.min_chl);
      setMaxChl(firmData.max_chl);
      setTotalRoom(firmData.total_room);
      setBabyStart(firmData.baby_start);
      setBabyEnd(firmData.baby_end);
      setChlStart(firmData.chl_start);
      setChlEnd(firmData.chl_end);
      setRIntId(firmData.int_ID);
      
    }
  }, [firmData]);

  const handleUpdate = () => {
    UpdateRoomType({
      variables: {
        firmSubCode: firmSubCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        rBed: rBed,
        minPax: minPax,
        maxPax: maxPax,
        minAdl: minAdl,
        maxAdl: maxAdl,
        minChl: minChl,
        maxChl:maxChl,
        totalRoom:totalRoom,
        babyStart: babyStart,
        babyEnd: babyEnd,
        chlStart: chlStart,
        chlEnd: chlEnd,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
    InsertRoomType({
      variables: {
        firmSubCode: firmSubCode,
        firmMainCode: firmMainCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        rBed: rBed,
        totalRoom: totalRoom,
        minPax:minPax,
        maxPax: maxPax,
        maxPax: maxPax,
        minAdl:minAdl,
        maxAdl: maxAdl,
        minChl: minChl,
        maxChl: maxChl,
        babyStart:babyStart,
        babyEnd:babyEnd,
        chlStart: chlStart,
        chlEnd:chlEnd,
        rIntId: rIntId,
        
    
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

return (
  <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    

    <div className="flex">
  <div className="mr-2 w-1/4">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {'room_class_code'}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rClassCode}
      onChange={(e) => setRClassCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_class_tab}
    </label>
    <Dropdown
      className="h-11 w-3/8  mr-2 rounded-md"
      style={{ flex: '3' }}
      value={rClassCode}
      options={roomClassSelectItemsC}
      onChange={(e) => setRClassCode(e.value)}
      placeholder={select_a_room_class}
    />
  </div>

  <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {typerec}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rTypeCode}
      onChange={(e) => setRTypeCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_type_tab}
    </label>
    <Dropdown
      className="h-11 w-3/8 rounded-md"
      style={{ flex: '2' }}
      value={rTypeCode}
      options={roomClassSelectItems}
      onChange={(e) => setRTypeCode(e.value)}
      placeholder={select_a_room_type}
    />
  </div>
</div>

<div className="flex mb-4">
  <div className="mt-4 w-2/4 pr-4">
    <label htmlFor="firmName" className="block font-medium text-gray-700">
      {room_type_tab}
    </label>
    <input
      type="text"
      id="firmName"
      name="firmName"
      value={rTypeName}
      onChange={(e) => setRTypeName(e.target.value)}
      className="mt-1 px-4 py-2 border w-full border-gray-300 focus:ring-blue-500 focus:border-blue-500 block rounded-md"
    />
  </div>

  <div className="mt-4 w-2/6 pr-4">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_bed_type_title}
    </label>
    <Dropdown
      className="w-full rounded-md"
      value={rBedType}
      options={roomClassSelectItemsB}
      onChange={(e) => setRBedType(e.value)}
      placeholder={select_a_bed_type}
    />
  </div>



  <div className="flex-auto mr-4 ml-2 mt-4 w-1/7">
  <label htmlFor="integeronly" className="font-medium block mb-1">{room_bed_title}</label>
  <InputNumber 
    inputId="integeronly"
    value={rBed} 
    onValueChange={(e) => setBed(e.value)}
    className="w-full h-11  border-gray-300 rounded-md "
  />
</div>

  <div className="flex-auto mr-4 ml-2 mt-4 w-1/7">
  <label htmlFor="integeronly" className="font-medium block mb-1">{room_total_title}</label>
  <InputNumber 
    inputId="integeronly"
    value={totalRoom} 
    onValueChange={(e) => setTotalRoom(e.value)}
    className="w-full h-11  border-gray-300 rounded-md "
  />
</div>
</div>




<div className="grid grid-cols-6">
  <div className="col-span-1">
    <div className="mr-2 inputtext ml-2"> {/* Genişliği 36rem veya uygun bir değer olarak ayarlayabilirsiniz */}
      <label htmlFor="minPax" className="font-medium">{room_min_pax_title}</label>
      <InputNumber 
        inputId="minPax"
        value={minPax} 
        onValueChange={(e) => setMinPax(e.value)}
        className="h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxPax" className="font-medium block">{room_max_pax_title}</label>
      <InputNumber 
        inputId="maxPax"
        value={maxPax} 
        onValueChange={(e) => setMaxPax(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className=" mr-2 ml-2">
      <label htmlFor="minAdl" className="font-medium block">Min Adl</label>
      <InputNumber 
        inputId="minAdl"
        value={minAdl} 
        onValueChange={(e) => setMinAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxAdl" className="font-medium block">Max Adl</label>
      <InputNumber 
        inputId="maxAdl"
        value={maxAdl} 
        onValueChange={(e) => setMaxAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="minChl" className="font-medium block">{room_chl_min_title}</label>
      <InputNumber 
        inputId="minChl"
        value={minChl} 
        onValueChange={(e) => setMinChl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxChl" className="font-medium">{room_chl_max_title}</label>
      <InputNumber 
        inputId="maxChl"
        value={maxChl} 
        onValueChange={(e) => setMaxChl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>
</div>

<div className="grid grid-cols-5 mt-4">
  <div className="col-span-1">
    <div className="mr-2 inputtext ml-2"> {/* Genişliği 36rem veya uygun bir değer olarak ayarlayabilirsiniz */}
      <label htmlFor="minPax" className="font-medium"> {room_baby_start_title}</label>
      <InputNumber 
        inputId="minPax"
        value={babyStart} 
        onValueChange={(e) => setBabyStart(e.value)}
        className="h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxPax" className="font-medium block"> {room_baby_end_title}</label>
      <InputNumber 
        inputId="maxPax"
        value={babyEnd} 
        onValueChange={(e) => setBabyEnd(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className=" mr-2 ml-2">
      <label htmlFor="minAdl" className="font-medium block">{room_chl_start_title}</label>
      <InputNumber 
        inputId="minAdl"
        value={chlStart} 
        onValueChange={(e) => setChlStart(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxAdl" className="font-medium block"> {room_chl_end_title}</label>
      <InputNumber 
        inputId="locale-user"
        value={chlEnd} 
        onValueChange={(e) => setChlEnd(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        maxFractionDigits={2}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="minChl" className="font-medium block">{int_id}</label>
      <InputNumber 
        inputId="minChl"
        value={rIntId} 
        onValueChange={(e) => setRIntId(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>
</div>

    <div className="mt-4 flex justify-end">
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleinsert}
      >
        {create_room_typerec}
      </button>
    </div>
  </div>
);
};

export default HotelRoomTypeCoop;
